<template>
  <div>
    <div class="add-custom-banner flex-start" style="background:#fff;margin:10rpx 0">
      <div
        class="add-custom-nav"
        v-for="(item,index) in content"
        :key="index"
        @click="onPicClick(item)"
      >
        <img class="add-custom-img" :src="item.pic_url" mode="widthFix" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "Pic",
  components: {
    Dialog
  },
  props: {
    content: {
      type: Array,
      default: []
    }
  },

  data: function() {
    return {};
  },

  methods: {
    onPicClick(item) {
      rbLink({
        name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
        query: item.url.query
      });
    }
  },

  filters: {}
};
</script>

<style scoped>
.add-custom-nav {
  width: 100%;
}
.add-custom-nav img {
  width: 7.1rem;
  margin: 0 auto;
  display: block;
}
</style>


// WEBPACK FOOTER //
// Pic.vue?2aef8674